/**
 * @fileoverview utils to make step data fetching easier
 * these could stand to be put into some sort of `@lib`
 */

export function flatten<T = unknown>(arrays: T[][]): T[] {
  if (arrays.length === 0) {
    return [];
  }
  if (arrays.length === 1) {
    return arrays[0];
  }
  return arrays.reduce((all, arr) => {
    all.push(...arr);
    return all;
  }, []);
}

export function wait(delay: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, delay));
}

export function shuffle<T = unknown>(array: T[]) {
  for (let i = array.length - 1; i >= 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    const temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
}

/**
 * Splits an array into a number of smaller arrays that are all smaller than
 * chunkSize, but otherwise evenly distributed. Order is not maintained.
 */
export function evenChunk<T = unknown>(array: T[], chunkSize: number): T[][] {
  if (array.length < chunkSize) {
    return [array];
  }
  const chunkCount = Math.ceil(array.length / chunkSize);
  const chunks: T[][] = Array.from({ length: chunkCount }, () => []);
  for (let i = 0; i < array.length; i++) {
    chunks[i % chunkCount].push(array[i]);
  }
  return chunks;
}
